/** Namen wie in `react-remove-scroll-bar/constants` (die Bibliothek `react-remove-scroll` importiert sie von hier). */
export const zeroRightClassName = 'right-scroll-bar-position';
export const fullWidthClassName = 'width-before-scroll-bar';
export const noScrollbarsClassName = 'with-scroll-bars-hidden';
/** CSS-Variable mit der Breite der ausgeblendeten Bildlaufleiste (steht in `scroll-lock.css`). */
export const removedBarSizeVariable = '--removed-body-scroll-bar-size';
